<template>
  <div class="related-products">
    <ProductCarousel class="related-products-carousel" title="Goes well with" :products="relatedProducts" @productClicked="onProductClicked" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ProductCarousel from '@/components/commons/ProductCarousel.vue';
import { formatPrice } from '@/components/commons/MoneyUtils.js';

export default {
  name: 'RelatedProducts',
  components: {
    ProductCarousel,
  },
  computed: {
    ...mapState('product', ['product']),
    ...mapGetters('common', ['currentCountry']),

    relatedProducts() {
      if (this.product && this.product.related) {
        return this.product.related.map((related) => {
          const price = formatPrice(related, this.currentCountry);
          return {
            id: related.hashKey,
            skuNo: related.skuNo,
            title: related.title,
            isOnSale: related.onSale,
            isOnClearance: related.onClearance,
            price: price.finalFormatted,
            priceOriginal: price.priceFormatted,
            url: this.$router.resolve({ name: 'product', params: { id: related.hashKey, slug: related.slug } }).href,
            productImage: {
              url: `${related.imageUrl}?fit=max&w={width}&q={q}`,
            },
          };
        });
      }
      return [];
    },
  },
  methods: {
    onProductClicked() {
      this.$emit('productClicked');
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.related-products {
  .related-products-carousel {
    margin-bottom: 0px;
  }
  .title {
    margin-bottom: 24px;
  }

  .browse-heading {
    font-size: var(--font-size-14);
  }

  .price {
    font-size: 1.1em;
    color: var(--coral);
  }
}
</style>
